export default __webpack_public_path__ + "static/media/reports.3a845224.svg";